// Jakte will be activated only if we are not in development mode
// Piaf with messages to clients will be activated only if we are not in development mode
const isDevelopment = false;

// Name of the project, will apprear on the contact form emails sent to the client
const projectName = 'Panoramic';

// Slug of the project, used to match it to the analytics.
// Must be set on the project's estate page on the backoffice
// Valid slug is required and sufficient for Jakte activation
const slug = 'panoramic-gentilly';

// Emails from agencies. The keys (here `agencyName`) are important as they'll be matched
// to determine which agency receives the contact
const agencyEmails = {
  agencyName: ['trash_it@drawbotics.com']
};

const devEmails = ['trash_it@drawbotics.com']

// Website domain, without the http(s):// prefix
const domain = 'panoramic-gentilly.fr';

// Full revo URL, false to disable the revo component
const revoUrl = false;

const locales = ['fr'];

const defaultLocale = 'fr';

// Source of the project, can be 'website' or 'landing'
const source = 'website';

// If the client has in-house tracking through Google Analytics
googleAnalyticsID = 'AW-567500731';

module.exports = {
  isDevelopment,
  projectName,
  slug,
  domain,
  revoUrl,
  locales,
  defaultLocale,
  source,
  agencyEmails,
  devEmails,
  googleAnalyticsID,
  isMultiLocale: locales.length > 1,
};


//////////////////
// WEBPACK FOOTER
// ./vars.js
// module id = 189
// module chunks = 0